// The words a visitor reads for a trail's difficulty and its primary
// use. The keys are what the trail form stores (StoreTrailRequest:
// easy, moderate, hard, expert, access, pro). The website's Trails
// block once keyed its labels on ski-run colors (green / blue /
// black) that no trail ever has, so every card showed no difficulty
// at all — one list here, so that cannot happen to one surface alone.

export const DIFFICULTY_KEYS = ['easy', 'moderate', 'hard', 'expert', 'access', 'pro'];

export const DIFFICULTY_LABELS = {
    easy: 'Easy', moderate: 'Moderate', hard: 'Hard', expert: 'Expert', pro: 'Pro', access: 'Access',
};

/** Same words as the dashboard's trail form (Trails/Edit.vue). */
export const PRIMARY_USE_LABELS = {
    mixed: 'Multi-use',
    hiking: 'Hiking',
    mtb: 'Mountain biking',
    gravel: 'Road / gravel biking',
    running: 'Trail running',
    equestrian: 'Equestrian',
    nordic: 'Nordic skiing',
    alpine: 'Alpine / backcountry skiing',
    snowshoe: 'Snowshoeing',
    fatbike: 'Fat biking',
    atv: 'ATV / OHV',
    snowmobile: 'Snowmobile',
    walking: 'Walking / accessible',
};

export function difficultyLabel(key) {
    return DIFFICULTY_LABELS[key] || '';
}

export function primaryUseLabel(key) {
    if (!key) return '';
    return PRIMARY_USE_LABELS[key] || String(key).charAt(0).toUpperCase() + String(key).slice(1);
}

// A trail's riding direction (StoreTrailRequest: bi-directional,
// downhill, uphill). Not the route's shape: a two-way trail whose start
// and finish are far apart is still two-way.
export const DIRECTION_LABELS = {
    'bi-directional': 'Both directions',
    downhill: 'Downhill only',
    uphill: 'Uphill only',
};
export function directionLabel(key) {
    return DIRECTION_LABELS[key] || '';
}
